/* set jquery globals */
const $ = window.jQuery;
const jQuery = window.jQuery;

/* app code here */
var heroSliderCurrent = 0;
var $heroSlider = $('.hero-slider-slides');
var $heroSlides = $('.hero-slider-slide');
var $heroSliderPagination = $('.hero-slider-pagination');
var $heroStats = $('.hero-slider-stat');
var heroSliderAuto;
var heroStatsAuto;

var video0 = $('.hero-slider-slide-nada-2020 .video-content').html();
var video8 = $('.hero-slider-slide-8 .video-content').html();-

$(function() {
    video0 = $('.hero-slider-slide-nada-2020 .video-content').html();
    video8 = $('.hero-slider-slide-8 .video-content').html();

    $('.hero-slider').removeClass('loading');
    $heroSlider.css('opacity', '1');

    heroSliderAuto = setInterval(function() {
        heroSliderMove(1);
    }, 21000);
    
    heroSliderResize();
    heroSliderPaginate();
    
    $heroSlides.first().addClass('active');

    if ($('.hero-slider-slide-nada-2020').hasClass('active')) {
        $('.hero-slider-slide-8 .video-content').html('');
        // $('.hero-slider-slide-nada-2020 .video-content').html(video0);
        // $('.hero-slider-slide-nada-2020 .video-content video').get(0).play();
    } else if ($('.hero-slider-slide-8').hasClass('active')) {
        $('.hero-slider-slide-nada-2020 .video-content').html('');
        $('.hero-slider-slide-8 .video-content').html(video8);
        $('.hero-slider-slide-8 .video-content video').get(0).play();
    } else {
        $('.hero-slider-slide-nada-2020 .video-content').html('');
        $('.hero-slider-slide-8 .video-content').html('');
    }
    
    if ($('.hero-slider-slide-1').hasClass('active')) {
        $heroStats.first().addClass('active');
        heroStatsRotate();
    }
    
    $(window).resize(function() {
        heroSliderResize();
    })
});

function heroStatsRotate() {
    if (!$heroStats.hasClass('active').length) {
        $heroStats.first().addClass('active');
    }
    
    heroStatsAuto = setInterval(function() {
        if ($('.hero-slider-stat.active').next().length) {
            $('.hero-slider-stat.active').removeClass('active').next().addClass('active');
        } else {
            $('.hero-slider-stat').removeClass('active').first().addClass('active');
        }
    }, 7000);
}

function heroSliderMove(dir) {
    heroSliderCurrent = heroSliderCurrent + dir;
    
    if (heroSliderCurrent > ($heroSlides.length - 1)) {
        heroSliderCurrent = 0;
    } else if (heroSliderCurrent < 0) {
        heroSliderCurrent = $heroSlides.length - 1;
    }
    
    heroSliderJump(heroSliderCurrent);
}

function heroSliderResize() {
    $heroSlider.width($('body').width() * $heroSlides.length);
    $heroSlides.width($('body').width());
}

function heroSliderJump(pos) {
    heroSliderCurrent = pos;
    
    var offset = (-100 * heroSliderCurrent) / $heroSlides.length;
    $heroSlider.css('transform', 'translateX(' + offset + '%)');
    $heroSlides.removeClass('active');
    $heroStats.removeClass('active');

    clearInterval(heroStatsAuto);
    
    $('.hero-slider-pagination a').removeClass('active');
    $('.hero-slider-slide:nth-child(' + (heroSliderCurrent + 1) + ')').addClass('active');
    $('.hero-slider-pagination a:nth-child(' + (heroSliderCurrent + 1) + ')').addClass('active');
    
    if ($('.hero-slider-slide-1').hasClass('active')) {
        $heroStats.first().addClass('active');
        heroStatsRotate();
    }

    if ($('.hero-slider-slide-nada-2020').hasClass('active')) {
        $('.hero-slider-slide-8 .video-content').html('');

        setTimeout(function() {
            $('.hero-slider-slide-nada-2020 .video-content').html(video0);

            if ($(document).width() >= 768) {
                console.log('big');
                $('.hero-slider-slide-nada-2020 .video-content video').each(function() {
                    // $(this).attr('src', $(this).attr('data-load-video'));
                    // $(this).get(0).play();
                });
            }
        }, 1000);
    } else if ($('.hero-slider-slide-8').hasClass('active')) {
        $('.hero-slider-slide-nada-2020 .video-content').html('');

        setTimeout(function() {
            $('.hero-slider-slide-8 .video-content').html(video8);

            if ($(document).width() >= 768) {
                $('.hero-slider-slide-8 .video-content video').each(function() {
                    $(this).attr('src', $(this).attr('data-load-video'));
                    $(this).get(0).play();
                });
            }
        }, 1000);
    } else {
        $('.hero-slider-slide-nada-2020 .video-content').html('');
        $('.hero-slider-slide-8 .video-content').html('');
    }
}

function heroSliderPaginate() {
    $heroSlides.each(function(index) {
        var link = $("<a href='" + (index) + "' />");
        if (index == 0) {
            link.addClass('active');
        }
        link.click(function(e) {
            e.preventDefault();
            heroSliderJump(parseInt($(this).attr('href')));
            clearInterval(heroSliderAuto);
        })
        $heroSliderPagination.append(link);
    })
}
